module.exports = __webpack_public_path__ + "static/img/6.87ec214.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/6.png
// module id = L0V+
// module chunks = 0